var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrescription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 198,
    viewBox: "0 0 164 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.92 197.095L24.8108 186.865L38.5988 16.7732L163.708 27.0032L149.92 197.095Z",
    fill: "url(#paint0_linear_2715_132)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.417 194.667L26.679 184.71L40.0964 19.2015L161.835 29.1563L148.417 194.667Z",
    fill: "#027EC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.615 168.495L32.3455 192.277L0.292725 24.6871L123.562 0.904755L155.615 168.495Z",
    fill: "url(#paint1_linear_2715_132)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.52 166.558L33.5731 189.701L2.38403 26.6234L122.331 3.48315L153.52 166.558Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.715 13.5629H15.1926V184.218H140.715V13.5629Z",
    fill: "url(#paint2_linear_2715_132)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.026 15.8611H16.884V181.917H139.026V15.8611Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.045 44.5125C58.1779 55.624 67.2566 64.5239 78.3207 64.3863C89.3848 64.2487 98.2515 55.1348 98.1135 44.0207C98.0703 39.8902 96.7538 35.8729 94.3425 32.5141C91.9312 29.1552 88.542 26.6174 84.6347 25.2451L84.696 30.4275C84.7233 32.2295 84.0333 33.9689 82.777 35.2646C81.5208 36.5602 79.8007 37.3066 77.9936 37.3401C76.1894 37.3503 74.4545 36.648 73.168 35.3866C71.8815 34.1253 71.148 32.4074 71.1278 30.6084L71.0664 25.426C67.1946 26.8913 63.8685 29.5086 61.5391 32.9229C59.2098 36.3373 57.9899 40.3834 58.045 44.5125Z",
    fill: "url(#paint3_linear_2715_132)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1194 42.3952C98.1194 31.2811 89.1505 22.2666 78.0839 22.2666C67.0172 22.2666 58.0484 31.276 58.0484 42.3952C58.0411 46.5264 59.3088 50.5598 61.6795 53.9479C64.0501 57.336 67.4089 59.9147 71.2998 61.334V56.1515C71.2984 54.3525 72.0111 52.626 73.2823 51.3494C74.5535 50.0728 76.2797 49.3498 78.0839 49.3383C79.888 49.3498 81.6142 50.0728 82.8854 51.3494C84.1566 52.626 84.8694 54.3525 84.868 56.1515V61.3365C88.7593 59.9171 92.1183 57.338 94.489 53.9494C96.8597 50.5608 98.1272 46.5269 98.1194 42.3952Z",
    fill: "#027EC6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0967 47.3637C82.3501 47.3637 85.7982 43.9004 85.7982 39.6282C85.7982 35.356 82.3501 31.8927 78.0967 31.8927C73.8433 31.8927 70.3953 35.356 70.3953 39.6282C70.3953 43.9004 73.8433 47.3637 78.0967 47.3637Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0844 49.3383C76.2803 49.3498 74.554 50.0728 73.2829 51.3494C72.0117 52.626 71.2989 54.3525 71.3003 56.1515V61.3365C75.6845 62.9152 80.4843 62.9152 84.8685 61.3365V56.1515C84.8699 54.3525 84.1571 52.626 82.886 51.3494C81.6148 50.0728 79.8885 49.3498 78.0844 49.3383Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3293 39.2001C69.7108 37.9973 69.4276 36.651 69.5091 35.3018C69.5968 33.9491 70.2089 32.6835 71.2159 31.7729C72.3377 30.8124 73.8581 30.4735 75.3273 30.3563C76.7966 30.2391 78.2863 30.3104 79.7325 30.0225C80.9298 29.7777 82.0663 29.2974 83.0753 28.6097C84.0844 27.922 84.9459 27.0406 85.6095 26.0172C85.7015 27.151 85.7935 28.3103 85.5763 29.4212C85.3591 30.5321 84.7867 31.6379 83.8209 32.2239C84.9912 31.6812 84.8634 32.9552 84.6104 33.717C85.1905 34.4202 86.5984 34.5374 86.67 35.447C86.7415 36.3566 86.7287 37.2968 86.3761 38.1351C86.0235 38.9734 86.4016 40.4537 85.4971 40.5174",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3293 39.2001C69.7108 37.9973 69.4276 36.651 69.5091 35.3018C69.5968 33.9491 70.2089 32.6835 71.2159 31.7729C72.3377 30.8124 73.8581 30.4735 75.3273 30.3563C76.7966 30.2391 78.2863 30.3104 79.7325 30.0225C80.9298 29.7777 82.0663 29.2974 83.0753 28.6097C84.0844 27.922 84.9459 27.0406 85.6095 26.0172C85.7015 27.151 85.7935 28.3103 85.5763 29.4212C85.3591 30.5321 84.7867 31.6379 83.8209 32.2239C84.9912 31.6812 84.8634 32.9552 84.6104 33.717C85.1905 34.4202 86.5984 34.5374 86.67 35.447C86.7415 36.3566 86.7287 37.2968 86.3761 38.1351C86.0235 38.9734 86.4016 40.4537 85.4971 40.5174",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2485 32.0558C84.2485 32.0558 89.6145 32.5272 85.797 40.5379L84.2485 32.0558Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9173 147.156H28.3262V163.819H44.9173V147.156Z",
    fill: "url(#paint4_linear_2715_132)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4856 148.593H29.7563V162.382H43.4856V148.593Z",
    fill: "#027EC6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1221 78.2039H58.0767V81.0779H98.1221V78.2039Z",
    fill: "#69F0AE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.583 82.227H58.0767V85.1011H125.583V82.227Z",
    fill: "#E0E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M125.583 86.2477H58.0767V89.1218H125.583V86.2477Z",
    fill: "#E0E0E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1221 114.117H58.0767V116.991H98.1221V114.117Z",
    fill: "#69F0AE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.583 118.137H58.0767V121.011H125.583V118.137Z",
    fill: "#E0E0E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M125.583 122.161H58.0767V125.035H125.583V122.161Z",
    fill: "#E0E0E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1221 150.027H58.0767V152.901H98.1221V150.027Z",
    fill: "#027EC6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M125.583 154.05H58.0767V156.925H125.583V154.05Z",
    fill: "#E0E0E0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M125.583 158.074H58.0767V160.948H125.583V158.074Z",
    fill: "#E0E0E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2715_132",
    x1: 87.332,
    y1: 191.997,
    x2: 101.133,
    y2: 21.8341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2715_132",
    x1: 133424,
    y1: 129793,
    x2: 109299,
    y2: 3799.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2715_132",
    x1: 65027.2,
    y1: 122793,
    x2: 65027.2,
    y2: 8491.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2715_132",
    x1: 79.3561,
    y1: 64.0614,
    x2: 77.3255,
    y2: 24.7831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2715_132",
    x1: 5937.57,
    y1: 10801.8,
    x2: 5937.57,
    y2: 9711.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescription);
export default __webpack_public_path__ + "static/media/prescription.ad09257a96ccbc2a49c594ff05fd01e1.svg";
export { ForwardRef as ReactComponent };